export const GET_PASSWORD_POLICY_ABORTED = 'GET_PASSWORD_POLICY_ABORTED';
export const GET_PASSWORD_POLICY_REQUESTED = 'GET_PASSWORD_POLICY_REQUESTED';
export const GET_PASSWORD_POLICY_COMPLETED = 'GET_PASSWORD_POLICY_COMPLETED';
export const GET_PASSWORD_POLICY_FAILED = 'GET_PASSWORD_POLICY_FAILED';
